<template>
  <div class="product-details">
    <a-card>
      <div class="fundSeries">
        <div class="fund-info">
          <span class="fund-info-title">{{ details.customerCode }}</span>
        </div>
      </div>
      <div class="scale">
        <div class="cost">
          <p>资产总额（元）</p>
          <p>{{ details.tdPlProfit && details.tdPlProfit.marketValue ? details.tdPlProfit.marketValue : '0.00' }}</p>
        </div>
        <div class="cost">
          <p>资产收益(元)</p>
          <p>{{ details.tdPlProfit && details.tdPlProfit.totalIncome ? details.tdPlProfit.totalIncome : '0.00' }}</p>
        </div>
        <div class="cost">
          <p>收益率</p>
          <p>
            {{
              details.tdPlProfit && details.tdPlProfit.yield
                ? (Number(details.tdPlProfit.yield) * 100).toFixed(2) + '%'
                : '0.00%'
            }}
          </p>
        </div>
        <div class="cost">
          <p>已投本金(元)</p>
          <p>
            {{
              details.tdPlProfit && details.tdPlProfit.totalAmount
                ? details.tdPlProfit.totalAmount
                : '0.00'
            }}
          </p>
        </div>
        <div class="cost">
          <p>已投期数</p>
          <p>{{ details.cycleCount || 0 }}</p>
        </div>
        <div class="cost">
          <p>状态</p>
          <div class="tag">
            <a-tag
              v-if="details.status || String(details.status)"
              :color="investStatusColor.isc1[details.status]"
              >{{ investStatusText.ist1[details.status] }}</a-tag
            >
            <a-tag
              v-if="details.targetStatus || String(details.targetStatus)"
              :color="investStatusColor.isc2[details.targetStatus]"
              >{{ investStatusText.ist2[details.targetStatus] }}</a-tag
            >
          </div>
        </div>
      </div>

      <div class="relevant_information">
        <a-tabs :default-active-key="tabIndex">
          <a-tab-pane key="1" tab="基本信息">
            <side-table
              :columns="columns"
              :columnsTable="columnsTable"
              :columnsCol="columnsCol"
            />
          </a-tab-pane>
          <a-tab-pane key="2" tab="定投历史"> 
            <fixedHistory />
          </a-tab-pane>
        </a-tabs>
      </div>
    </a-card>
  </div>
</template>
<script>
import { getAction } from '@/api/manage';
import sideTable from './modules/sideTable.vue';
import fixedHistory from './modules/fixedHistory.vue';

export default {
  data() {
    const tdPlFundsCol = [
      {
        title: '产品名称',
        align: 'center',
        dataIndex: 'fundName',
        key: 'fundName',
        width: 100,
      },
      {
        title: '产品代码',
        align: 'center',
        dataIndex: 'fundCode',
        key: 'fundCode',
        width: 100,
      },
      {
        title: '初始持仓本金（元）',
        align: 'center',
        dataIndex: 'initAmount',
        key: 'initAmount',
        width: 100,
      },
      {
        title: '初始持仓份额（份）',
        align: 'center',
        dataIndex: 'initPart',
        key: 'initPart',
        width: 100,
      },
      {
        title: '初始持仓盈亏（元）',
        align: 'center',
        dataIndex: 'initProfit',
        key: 'initProfit',
        width: 100,
      },
      {
        title: '每期定投金额（元）',
        align: 'center',
        dataIndex: 'amount',
        key: 'amount',
        width: 100,
      },
      {
        title: '定投周期',
        align: 'center',
        dataIndex: 'cycleType',
        key: 'cycleType',
        width: 200,
      },
      {
        title: '定投开始时间',
        align: 'center',
        dataIndex: 'startTime',
        key: 'startTime',
        width: 100,
      },
    ];
    return {
      tabIndex: '1',
      details: {},
      url: process.env.VUE_APP_CMS_TRADEBIZ + '/tdPlPlan/info',
      investStatusColor: {
        isc1: ['orange', 'blue', 'red', ''],
        isc2: ['', 'green'],
      },
      investStatusText: {
        ist1: ['计划暂停中', '计划进行中', '计划已终止', '计划未开始'],
        ist2: ['未达标', '已达标'],
      },
      columns: {
        planName: {
          title: '计划名称',
          value: '',
        },
        planType_dictText: {
          title: '定投类型',
          value: '',
        },
        memberName: {
          title: '姓名',
          value: '',
        },
        customerCode: {
          title: '关联客户',
          value: '',
        },
        rebate: {
          title: '费率折扣',
          value: '',
        },
        target: {
          title: '定投目标',
          value: '',
        },
        tdPlFunds: {
          title: '定投产品',
          value: [],
        },
      },
      columnsTable: ['tdPlFunds'],
      columnsCol: {
        tdPlFunds: tdPlFundsCol,
      },
    };
  },
  components: {
    sideTable,
    fixedHistory
  },
  mounted() {
    this.getDetails();
  },
  methods: {
    getDetails() {
      const id = this.$route.query.id;
      getAction(this.url, { id }).then((res) => {
        if (res.success) {
          this.details = res.result ? res.result : {};
          if (this.details && Object.keys(this.details).length) {
            for (let k in this.columns) {
              if (k === 'rebate') {
                if (
                  this.details.tdPlFunds &&
                  this.details.tdPlFunds[0] &&
                  this.details.tdPlFunds[0][k]
                ) {
                  this.columns[k].value = this.details.tdPlFunds[0][k] + '%';
                }
              } 
              // 后端取不到字典值,从分页查询携带渲染
              else if (k === 'planType_dictText') {
                this.columns.planType_dictText.value=this.$route.query.planType_dictText
              }
               else if (k === 'memberName') {
                this.columns[k].value =
                  this.details[k] + `（经理ID：${this.details.memberId}）`;
              } else if (k === 'target') {
                const t = ['期数', '资产', '收益率', '收益额'];
                let str = '';
                if (this.details.targetType){
                  str = '目标类型：' + t[this.details.targetType];
                }
                if (this.details.targetValue){
                  str += ' 目标金额：' + this.details.targetValue || 0;
                }
                this.columns[k].value = str;
              } else if (k === 'tdPlFunds') {
                const arr = this.details[k] || [];
                if (arr.length) {
                  for (let i = 0; i < arr.length; i++) {
                    this.$set(arr[i], 'startTime', this.details.startTime);
                    const s = ['每周', '每双周', '每月'];
                    let day = '';
                    if (this.details.cycleType == 3) {
                      day = this.details.cycleValue + '号';
                    } else {
                      day = '周' + this.details.cycleValue;
                    }
                    let cycle = s[this.details.cycleType - 1] + ' ' + day;
                    this.$set(arr[i], 'cycleType', cycle);
                  }
                }
                this.columns[k].value = arr;
              } else {
                this.columns[k].value = this.details[k] || '';
              }
            }
          }
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.product-details {
  width: 100%;
  .fundSeries {
    width: 100%;
    display: flex;
    justify-content: space-between;
    .fund-info {
      width: 80%;
      height: 45px;
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;
      margin-bottom: 20px;
      .fund-info-title {
        color: #666;
        font-size: 16px;
      }
    }
  }
  .scale {
    display: flex;
    background: #fff;
    .cost {
      display: flex;
      align-items: center;
      flex-direction: column;
      box-sizing: border-box;
      width: 260px;
      p {
        font-size: 14px;
        font-weight: bold;
        color: #333;
        &:nth-child(2n) {
          font-size: 22px;
          color: #f69a00;
        }
      }
      .tag {
        margin-top: 4px;
        .ant-tag {
          padding: 2px 8px;
        }
      }
    }
  }
}
</style>